const CardStyle: string =
  "flex flex-col w-full h-full bg-white dark:bg-dark border border-neutral-400/20 dark:border-neutral-600/10 rounded-3xl p-6 items-start justify-between ";

export default CardStyle;
